// extracted by mini-css-extract-plugin
module.exports = {"container":"item-content_container__3nYjI","content-body":"item-content_content-body__35_Tz","image":"item-content_image__21tWZ"};